import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss']
})
export class SidePanelComponent {
  @Input() quarter: number;
  @Input() time: number;
  @Input() mcc: number;
  @Input() tposm_p1: number;
  @Input() tposm_p4: number;
  @Input() tposm_p5: number;
  @Input() tposm_full: number;
  @Input() incentives: number;
  @Input() disabled?: boolean = false;
}
